<div class="share-with-others">
  <p-dialog
    header="{{ reviewSharingRequest ? 'Review Sharing Request' : 'Shared Authority' }}"
    [(visible)]="modelOpenStatus"
    (onHide)="closeModel()"
    [modal]="true"
    class="share-with-others"
    [responsive]="true"
  >
    <div>
      <span class="title-text-authority">Authority</span><span class="title-text-authority-id"> #{{ authority.ec1Number }}</span>
    </div>
    <div class="sharing-text" *ngIf="reviewSharingRequest"><strong>Do you want to Accept / Decline Sharing Request? </strong></div>
    <div class="sharing-text" *ngIf="!reviewSharingRequest">
      <strong>Authority can't be Released as it is shared with the following.</strong>
    </div>
    <div class="eic-list">
      <div *ngFor="let eic of eicListArray; let i = index" class="table-eiclist">
        <div *ngIf="reviewSharingRequest" class="table-eiclist-status">
          <div class="left">
            <i class="csx-people_user"></i>
            <span
              >{{ eic.eicUserId }} - {{ eic.eicEmployeeName }} {{ ' (' + eic.entryMilepostPrefix + ' ' + eic.entryMilepostId + ')' }}</span
            >
          </div>
          <div>
            <div class="right">
              <div class="reject-radio">
                <p-radioButton
                  name="{{ i }}"
                  value="1"
                  (click)="addToEicList(eic, 1)"
                  [(ngModel)]="eic.selected"
                  label="Reject"
                ></p-radioButton>
              </div>
              <div class="accept-radio">
                <p-radioButton
                  name="{{ i }}"
                  value="2"
                  (click)="addToEicList(eic, 2)"
                  [(ngModel)]="eic.selected"
                  label="Accept"
                ></p-radioButton>
              </div>
            </div>
          </div>
        </div>
        <div class="request-reason" *ngIf="reviewSharingRequest">
          <p *ngIf="eic.comment"><span>Reason:</span>{{ eic.comment }}</p>
          <div class="form-field" *ngIf="eic.selected === '1'">
            <label>Reject Reason<span>(Optional)</span></label>
            <textarea rows="3" [(ngModel)]="eic.rejectReason"></textarea>
          </div>
        </div>
        <div *ngIf="!reviewSharingRequest">
          <div class="left">
            <i class="csx-people_user"></i>
            <span
              >{{ eic.eicUserId }} - {{ eic.eicEmployeeName }}{{ ' (' + eic.entryMilepostPrefix + ' ' + eic.entryMilepostId + ')' }}</span
            >
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div *ngIf="!reviewSharingRequest"><strong>Do you want to "Unshare" first?</strong></div>
    <p-footer>
        <ng-container class="footer" *ngIf="reviewSharingRequest else unshareReviewSharingRequest">
          <button pButton label="Review Later" type="button" class="ui-button-info button-cancel p-button-outlined" (click)="closeModel()"></button>
          <button pButton label="Apply Now" class="ui-button-info" (click)="onSubmit()" [disabled]="!valueSelected"></button>
        </ng-container>
        <ng-template class="footer" #unshareReviewSharingRequest>
          <button pButton label="No, Cancel Request" type="button" class="ui-button-info button-cancel p-button-outlined" (click)="closeModel()"></button>
          <button pButton label="Yes, Unshare Authority" class="ui-button-info" (click)="onSubmitReleaseShareAuthority()"></button>
        </ng-template>
    </p-footer>
  </p-dialog>
</div>
